import { createGlobalStyle } from 'styled-components'

import RingsideBook from '../fonts/Ringside-Book.woff2'
import RingsideMedium from '../fonts/Ringside-Medium.woff2'
import RingsideBold from '../fonts/Ringside-Bold.woff2'
import TungstenBold from '../fonts/Tungsten-Bold.woff2'

import TungstenNarrow from '../fonts/TungstenNarrow-Bold.woff2'
import TungstenCondensed from '../fonts/TungstenCondensed-Bold.woff2'
import TungstenCompressed from '../fonts/TungstenCompressed-Bold.woff2'

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Ringside';
    src: local('Ringside Book'), local('Ringside-Book'),
        url(${RingsideBook}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ringside';
    src: local('Ringside Medium'), local('Ringside-Medium'),
        url(${RingsideMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ringside';
    src: local('Ringside Bold'), local('Ringside-Bold'),
        url(${RingsideBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Tungsten';
    src: local('Tungsten Bold'), local('Tungsten-Bold'),
        url(${TungstenBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
      font-family: 'Tungsten Narrow';
      src: local('Tungsten Narrow Bold'), local('TungstenNarrow-Bold'),
          url(${TungstenNarrow}) format('woff2');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
  }

  @font-face {
    font-family: 'Tungsten Condensed';
    src: local('Tungsten Condensed Bold'), local('TungstenCondensed-Bold'),
        url(${TungstenCondensed}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Tungsten Compressed';
    src: local('Tungsten Compressed Bold'), local('TungstenCompressed-Bold'),
        url(${TungstenCompressed}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  :root {
    --font-display: 'Tungsten', sans-serif;
    --font-sans: 'Ringside', sans-serif;
    
    --header-height: 5.6rem;
    --max-width: 128rem;
    --padding-x: var(--size-4);
    --grid-columns: repeat(16, minmax(0, 1fr));
    --border-width: 2px;

    --color-gradient: linear-gradient(
      to top,
      hsla(189, 16%, 11%, 1) 0%,
      hsla(189, 16%, 11%, 0.987) 4.7%,
      hsla(189, 16%, 11%, 0.951) 8.8%,
      hsla(189, 16%, 11%, 0.896) 12.4%,
      hsla(189, 16%, 11%, 0.825) 15.6%,
      hsla(189, 16%, 11%, 0.741) 18.5%,
      hsla(189, 16%, 11%, 0.648) 21.2%,
      hsla(189, 16%, 11%, 0.55) 23.75%,
      hsla(189, 16%, 11%, 0.45) 26.25%,
      hsla(189, 16%, 11%, 0.352) 28.8%,
      hsla(189, 16%, 11%, 0.259) 31.5%,
      hsla(189, 16%, 11%, 0.175) 34.4%,
      hsla(189, 16%, 11%, 0.104) 37.6%,
      hsla(189, 16%, 11%, 0.049) 41.2%,
      hsla(189, 16%, 11%, 0.013) 45.3%,
      hsla(189, 16%, 11%, 0) 50%,
      hsla(189, 16%, 11%, 0) 100%
    );
    
    @media (min-width: 768px) {
      --padding-x: var(--size-5);
    }
    
    @media (min-width: 1024px) {
      --padding-x: var(--size-6);
    }

    // Naming Convention Ideas...
    /*
    --color-light: var();
    --color-dark: var();
    --color-primary: var();
    --color-secondary: var();
    --color-link: var();
    --color-link-visited: var();
    --color-background: var();
    --color-text1: var();
    --color-text2: var(); 
    --color-surface1: var();
    --color-surface2: var();
    --color-surface3: var();
    --color-surface4: var();
    --swiper-theme-color: ...
    */

    /* Light */
    /* --color-light-light: #e1e8e9;
    --color-dark-light: #171d20;
    --color-primary-light: #4db6c9;
    --color-secondary-light: #d19331;
    --color-link-light: #171d20;
    --color-link-visited-light: #171d20;
    --color-background-light: #e1e8e9;
    --color-text1-light: #171d20;
    --color-text2-light: #171d20;
    --color-surface1-light: #cbd1d2;
    --color-surface2-light: #b4baba;
    --color-surface3-light: #9ea2a3;
    --color-surface4-light: #878b8c; */

    /* Dark */
    --color-white-dark: hsl(189, 0%, 100%);
    --color-light-dark: hsl(189, 15%, 90%);
    --color-dark-dark: hsla(189, 16%, 11%);
    --color-primary-dark: hsl(189, 53%, 55%);
    --color-secondary-dark: hsl(39, 73%, 55%);
    --color-link-dark: hsl(189, 15%, 90%);
    --color-link-visited-dark: hsl(189, 25%, 75%);
    --color-background-dark: hsla(189, 16%, 11%);
    --color-text1-dark: hsl(189, 15%, 90%);
    --color-text2-dark: hsl(189, 15%, 75%);
    --color-text1-inverted-dark: hsl(189, 15%, 90%);
    --color-text2-inverted-dark: hsl(189, 25%, 75%);
    --color-highlight-dark: hsl(189, 53%, 55%);
    --color-surface1-dark: hsl(189, 16%, 13%);
    --color-surface2-dark: hsl(189, 16%, 15%);
    --color-surface3-dark: hsl(189, 16%, 17%);
    --color-surface4-dark: hsl(189, 16%, 19%);

    /* NWA */
    /* --color-light-nwa: #f1f1fb;
    --color-dark-nwa: #08192e;
    --color-primary-nwa: #0064ca;
    --color-secondary-nwa: #c9e06a;
    --color-link-nwa: #c9e06a;
    --color-link-visited-nwa: #c9e06a;
    --color-background-nwa: #08192e;
    --color-text1-nwa: #f1f1fb;
    --color-text2-nwa: #0064ca;
    --color-surface1-nwa: #0b203b;
    --color-surface2-nwa: #243954;
    --color-surface3-nwa: #55657a;
    --color-surface4-nwa: #8691a0; */

    /* WWF */
    /* --color-light-wwf: #eef1f5;
    --color-dark-wwf: #16222c;
    --color-primary-wwf: #6fa9dc;
    --color-secondary-wwf: #fee304;
    --color-link-wwf: #fee304;
    --color-link-visited-wwf: #fee304;
    --color-background-wwf: #16222c;
    --color-text1-wwf: #eef1f5;
    --color-text2-wwf: #eef1f5;
    --color-surface1-wwf: #2c4458;
    --color-surface2-wwf: #436584;
    --color-surface3-wwf: #5987b0;
    --color-surface4-wwf: #6fa9dc; */

    /* WCW */
    /* --color-light-wcw: #fdfdff;
    --color-dark-wcw: #100b18;
    --color-primary-wcw: #523579;
    --color-secondary-wcw: #ffda27;
    --color-link-wcw: #ffda27;
    --color-link-visited-wcw: #ffda27;
    --color-background-wcw: #100b18;
    --color-text1-wcw: #fdfdff;
    --color-text2-wcw: #ffda27;
    --color-surface1-wcw: #211530;
    --color-surface2-wcw: #312049;
    --color-surface3-wcw: #422a61;
    --color-surface4-wcw: #523579; */

    /* Mono */
    /* --color-light-mono: var(--gray-0);
    --color-dark-mono: var(--gray-9);
    --color-primary-mono: var(--gray-0);
    --color-secondary-mono: var(--gray-6);
    --color-link-mono: var(--gray-7);
    --color-link-visited-mono: var(--gray-5);
    --color-background-mono: var(--gray-3);
    --color-text1-mono: var(--gray-7);
    --color-text2-mono: var(--gray-5); 
    --color-surface1-mono: var(--gray-1);
    --color-surface2-mono: var(--gray-2);
    --color-surface3-mono: var(--gray-3);
    --color-surface4-mono: var(--gray-4); */

    color-scheme: light;

    --color-light: var(--color-light-dark);
    --color-dark: var(--color-dark-dark);
    --color-primary: var(--color-primary-dark);
    --color-secondary: var(--color-secondary-dark);
    --color-link: var(--color-link-dark);
    --color-link-visited: var(--color-link-visited-dark);
    --color-background: var(--color-background-dark);
    --color-text1: var(--color-text1-dark);
    --color-text2: var(--color-text2-dark);
    --color-text1-inverted: var(--color-text1-inverted-dark);
    --color-text2-inverted: var(--color-text2-inverted-dark);
    --color-highlight: var(--color-highlight-dark);
    --color-surface1: var(--color-surface1-dark);
    --color-surface2: var(--color-surface2-dark);
    --color-surface3: var(--color-surface3-dark);
    --color-surface4: var(--color-surface4-dark);
  }
  
  @media (prefers-color-scheme: dark) {
    :root {
      color-scheme: dark;

      --color-light: var(--color-light-dark);
      --color-dark: var(--color-dark-dark);
      --color-primary: var(--color-primary-dark);
      --color-secondary: var(--color-secondary-dark);
      --color-link: var(--color-link-dark);
      --color-link-visited: var(--color-link-visited-dark);
      --color-background: var(--color-background-dark);
      --color-text1: var(--color-text1-dark);
      --color-text2: var(--color-text2-dark);
      --color-text1-inverted: var(--color-text1-inverted-dark);
      --color-text2-inverted: var(--color-text2-inverted-dark);
      --color-highlight: var(--color-highlight-dark);
      --color-surface1: var(--color-surface1-dark);
      --color-surface2: var(--color-surface2-dark);
      --color-surface3: var(--color-surface3-dark);
      --color-surface4: var(--color-surface4-dark);
    }
  }

  [color-scheme="light"] {
    color-scheme: light;

    --color-light: var(--color-light-dark);
    --color-dark: var(--color-dark-dark);
    --color-primary: var(--color-primary-dark);
    --color-secondary: var(--color-secondary-dark);
    --color-link: var(--color-link-dark);
    --color-link-visited: var(--color-link-visited-dark);
    --color-background: var(--color-background-dark);
    --color-text1: var(--color-text1-dark);
    --color-text2: var(--color-text2-dark);
    --color-surface1: var(--color-surface1-dark);
    --color-surface2: var(--color-surface2-dark);
    --color-surface3: var(--color-surface3-dark);
    --color-surface4: var(--color-surface4-dark);
  }

  [color-scheme="dark"] {
    color-scheme: dark;

    --color-light: var(--color-light-dark);
    --color-dark: var(--color-dark-dark);
    --color-primary: var(--color-primary-dark);
    --color-secondary: var(--color-secondary-dark);
    --color-link: var(--color-link-dark);
    --color-link-visited: var(--color-link-visited-dark);
    --color-background: var(--color-background-dark);
    --color-text1: var(--color-text1-dark);
    --color-text2: var(--color-text2-dark);
    --color-surface1: var(--color-surface1-dark);
    --color-surface2: var(--color-surface2-dark);
    --color-surface3: var(--color-surface3-dark);
    --color-surface4: var(--color-surface4-dark);
  }

  /* [color-scheme="wwf"] {
    color-scheme: --color-dark;

    --color-light: var(--color-light-wwf);
    --color-dark: var(--color-dark-wwf);
    --color-primary: var(--color-primary-wwf);
    --color-secondary: var(--color-secondary-wwf);
    --color-link: var(--color-link-wwf);
    --color-link-visited: var(--color-link-visited-wwf);
    --color-background: var(--color-background-wwf);
    --color-text1: var(--color-text1-wwf);
    --color-text2: var(--color-text2-wwf);
    --color-surface1: var(--color-surface1-wwf);
    --color-surface2: var(--color-surface2-wwf);
    --color-surface3: var(--color-surface3-wwf);
    --color-surface4: var(--color-surface4-wwf);
  } */

  /* [color-scheme="nwa"] {
    color-scheme: --color-dark;

    --color-light: var(--color-light-nwa);
    --color-dark: var(--color-dark-nwa);
    --color-primary: var(--color-primary-nwa);
    --color-secondary: var(--color-secondary-nwa);
    --color-link: var(--color-link-nwa);
    --color-link-visited: var(--color-link-visited-nwa);
    --color-background: var(--color-background-nwa);
    --color-text1: var(--color-text1-nwa);
    --color-text2: var(--color-text2-nwa);
    --color-surface1: var(--color-surface1-nwa);
    --color-surface2: var(--color-surface2-nwa);
    --color-surface3: var(--color-surface3-nwa);
    --color-surface4: var(--color-surface4-nwa);
  } */

  /* [color-scheme="wcw"] {
    color-scheme: --color-dark;

    --color-light: var(--color-light-wcw);
    --color-dark: var(--color-dark-wcw);
    --color-primary: var(--color-primary-wcw);
    --color-secondary: var(--color-secondary-wcw);
    --color-link: var(--color-link-wcw);
    --color-link-visited: var(--color-link-visited-wcw);
    --color-background: var(--color-background-wcw);
    --color-text1: var(--color-text1-wcw);
    --color-text2: var(--color-text2-wcw);
    --color-surface1: var(--color-surface1-wcw);
    --color-surface2: var(--color-surface2-wcw);
    --color-surface3: var(--color-surface3-wcw);
    --color-surface4: var(--color-surface4-wcw);
  } */
  
  /* [color-scheme="mono"] {
    color-scheme: --color-light;

    --color-light: var(--color-light-mono);
    --color-dark: var(--color-dark-mono);
    --color-primary: var(--color-primary-mono);
    --color-secondary: var(--color-secondary-mono);
    --color-link: var(--color-link-mono);
    --color-link-visited: var(--color-link-visited-mono);
    --color-background: var(--color-background-mono);
    --color-text1: var(--color-text1-mono);
    --color-text2: var(--color-text2-mono);
    --color-surface1: var(--color-surface1-mono);
    --color-surface2: var(--color-surface2-mono);
    --color-surface3: var(--color-surface3-mono);
    --color-surface4: var(--color-surface4-mono);
  } */

  #___gatsby {
    height: 100%;
  }

  #gatsby-focus-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    height: 100%;
  }
  
  body {
    font-family: var(--font-sans);
    font-size: var(--size-3);
    max-width: 100vw;
    background: var(--color-background);
    color: var(--color-text1);
  }

  a {
    position: relative;
    color: inherit;
    text-decoration: none;
  }

  a.mod-underline {
    display: inline-block;
    overflow: hidden;
    padding-bottom: var(--border-width);


    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: var(--border-width);
      background: var(--color-primary);
      transform: translate3d(-101%, 0, 0);
      transition: opacity 300ms, transform 300ms;
    }

    &:hover::after,
    &:focus::after {
      transform: translate3d(0, 0, 0);
    }
  }

  ul, ol {
    list-style: none;
  }
  
  pre {
    display: block;
    overflow: auto;
    background: var(--color-surface1);
    padding: var(--size-6);
    margin: var(--size-4) 0 var(--size-8);
    border-radius: var(--radius-2);
  }

  .u-sr-only:not(:focus):not(:active) {
    position: absolute;
    width: 1px;
    height: 1px;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
    overflow: hidden;
  }

  .swiper-button-next, .swiper-button-prev {
    color: var(--color-primary) !important;
    transition: color 250ms;

    &:hover {
      color: var(--color-secondary) !important;
    }
  }

  .swiper-pagination-bullet {
    opacity: 0.5 !important;
    transition: opacity 250ms, background 250ms;

    &:hover {
      background: var(--color-secondary) !important;
      opacity: 1 !important;
    }
  }
  
  .swiper-pagination-bullet-active {
    background: var(--color-primary) !important;
    opacity: 1 !important;

    &:hover {
      background: var(--color-primary) !important;
    }
  }

`

export default GlobalStyles
